import { styled } from '@mui/system';
import Button, { ButtonProps } from '@mui/material/Button';


interface SwitchCategoryButtonProps extends ButtonProps {
    active?: boolean;
    name: string;
}

export const SwitchCategoryButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'active',
})<SwitchCategoryButtonProps>(({ active, theme }) => ({
    ...(active &&
    {
        justifyContent: 'center',
        color: 'white',
        backgroundColor: theme.palette.secondary.main,
        borderRadius: 6,
        paddingLeft: '25px',
        paddingRight: '25px',
        marginRight: 0,
        marginLeft: 0,
        fontWeight: 400,
        minWidth: 100,
        '&:hover': {
            borderRadius: 6,
            backgroundColor: theme.palette.text.secondary,
            color: theme.palette.text.color
        },
    }),
    ...(!active &&
    {
        justifyContent: 'center',
        backgroundColor: theme.palette.action.active,
        borderRadius: 6,
        paddingLeft: '25px',
        paddingRight: '25px',
        marginRight: 0,
        marginLeft: 0,
        fontWeight: 400,
        color: theme.palette.text.primary,
        '&:hover': {
            borderRadius: 6,
            color: theme.palette.secondary.color
        },
    })
}));